//React imports
import React, { useState } from 'react';

//Redux imports
import { useDispatch } from 'react-redux';
import * as actions from '../store/actions/profileActions';

//Material UI Components
import { makeStyles, useTheme } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

//Virtue Components
import VirtuesPreference from '../components/Profile/virtues/VirtuesPreference';
import VirtuesEthnicity from '../components/Profile/virtues/VirtuesEthnicity';
import VirtuesReligion from '../components/Profile/virtues/VirtuesReligion';
import VirtuesPolitics from '../components/Profile/virtues/VirtuesPolitics';
import VirtuesSmoke from '../components/Profile/virtues/VirtuesSmoke';
import VirtuesDrink from '../components/Profile/virtues/VirtuesDrink';
import VirtuesHeight from '../components/Profile/virtues/VirtuesHeight';

//CSS Styles
import '../assets/css/style.css';

const useStyles = makeStyles({
    root: {
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

const getSteps = () => {
    return ["preference", "ethnicity", "religion", "political view", "smoking", "drinking", "height"];
}

const getStepHeading = () => {
    return [
        "Firstly, who would you prefer to date?", 
        "What is your Ethnicity?", 
        "What are your Religious Beliefs?", 
        "What are your political views?", 
        "Do you smoke?", 
        "Do you drink?",
        "How tall are you?"
    ];
}

const getStepContent = (step) => {
    switch (step) {
        case 0:
            return <VirtuesPreference />;
        case 1:
            return <VirtuesEthnicity />;
        case 2:
            return <VirtuesReligion />;
        case 3:
            return <VirtuesPolitics />;
        case 4:
            return <VirtuesSmoke />;
        case 5:
            return <VirtuesDrink />;
        case 6:
            return <VirtuesHeight />;
        default:
            return 'Unknown step';
    }
}

const ProfileVirtues = () => {
    const steps = getSteps();
    const classes = useStyles();
    const theme = useTheme();
    const stepsHeading = getStepHeading();
    const [activeStep, setActiveStep] = useState(0);

    const dispatch = useDispatch();
    
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        dispatch(actions.nextVirtue());
    };
    
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        dispatch(actions.previousVirtue());
    }
    
    return (
        <div style={{marginBottom:'40px'}}>
            <div className="step-heading-row">
                <div className="row-4">
                    {activeStep > 0 ?
                        <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                            {steps[activeStep-1]}
                        </Button> : null
                    }
                    <h3 style={{margin: '1.38rem 2rem 1.38rem 2rem'}}>{stepsHeading[activeStep]}</h3>
                    {activeStep < 6 ?
                        <Button size="small" onClick={handleNext} disabled={activeStep === 6}>
                            {steps[activeStep+1]}
                            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                        </Button> : null
                    }
                </div>
                <p>Please fill in all your virtues it is very important as it is used to recommend you to other user</p>
            </div>
            <MobileStepper
                variant="dots"
                steps={7}
                position="static"
                activeStep={activeStep}
                className={classes.root} />
            {getStepContent(activeStep)}
        </div>
    );
};

export default ProfileVirtues;